import { render, staticRenderFns } from "./RecentJobReportsList.vue?vue&type=template&id=4a6182f3&"
import script from "./RecentJobReportsList.vue?vue&type=script&lang=ts&"
export * from "./RecentJobReportsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports